import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/Button';
import AiSettings from '../../components/app/settings/AiSettings';

export const Settings = () => {
  const { session, profile } = useAuth();

  return (
    <div className="max-w-3xl">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900">Account Settings</h1>
        <p className="mt-2 text-slate-600">Manage your account security and preferences.</p>
      </header>

      <div className="space-y-6">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          <h3 className="text-lg font-bold text-slate-900 mb-4">Account Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-slate-500">Email Address</p>
              <p className="mt-1 text-slate-900">{session.user.email}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-slate-500">Account Status</p>
              <p className="mt-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 capitalize">
                {profile?.account_status || 'Active'}
              </p>
            </div>
          </div>
        </div>

        <AiSettings />

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          <h3 className="text-lg font-bold text-slate-900 mb-2">Password & Security</h3>
          <p className="text-slate-600 mb-6 text-sm">Security settings will be implemented in a future stage.</p>
          <Button variant="secondary" disabled>Change Password</Button>
        </div>

        <div className="bg-white rounded-2xl border border-red-100 shadow-sm p-8">
          <h3 className="text-lg font-bold text-red-600 mb-2">Danger Zone</h3>
          <p className="text-slate-600 mb-6 text-sm">Once you delete your account, there is no going back. Please be certain.</p>
          <Button variant="danger" disabled>Delete Account</Button>
        </div>
      </div>
    </div>
  );
};